<template >
    <div class="garyaBg montserrat overflow-hidden">
        <section class="w-full  text-white h-full background-wangos">
    <div class="container mx-auto py-10 md:py-44 lg:py-24">
      <div class=" flexmobile   items-center ">
        <div class="lg:w-2/3 mb-8 lg:mb-0">
          <h1 class="text-3xl sm:text-md md:text-5xl  font-bold mb-6">
            Warrior Wagons INC.
                  </h1>
          <h2 class="text-2xl md:text-4xl  font-medium">
            Website Redesign for Non-profit Organization 
          </h2>
        </div>
        <div class="lg:w-full animate__animated animate__zoomInRight">
          <img
          loading="lazy"
            src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726660877/file_1_gfj6vz.png"
            alt="Eater Chicago website mockup"
            class="w-full  mx-auto"
          />
        </div>
      </div>
    </div>
  </section>
  <!-- end of first hero section -->
  <div class="flex  mx-auto flex-col pt-2.5">
    <main class="flex flex-col items-start px-4 md:px-20 mt-10 md:mt-4  w-full">
        <!-- section two -->
      <section class="w-full mt-10">
        <div class="flex flex-col gap- md:flex-row justify-between">
          <div class="w-full md:w-6/12">
            <section class="flex flex-col rounded-none max-w-[917px]">
      <h1 class="self-start text-4xl font-semibold text-white">My Role</h1> 
      <ul class="mt-5  w-full text-lg text-white max-md:max-w-full">
        <li class="pt-6 text-lg ">
          Helped conduct <span class="text-rose-300">research surveys</span>
        </li>
        <li class="pt-4 text-lg ">
          Analyzed the collected data to <span class="text-rose-300">identify product gaps</span>
        </li>
        <li class="pt-4 text-lg ">
          <span class="text-rose-300">Redesigned Information Architecture</span> for seamless navigation
        </li>
        <li class="pt-4 text-lg ">
          Revamped the website visually in alignment with existing <span class="text-rose-300">design system</span>
        </li>
        <li class="pt-4 text-lg ">
          <span class="text-rose-300">Led</span> ideation strategy meetings and curated design collaterals for <span class="text-rose-300">Social Media Marketing</span>
        </li>
      </ul>
      
    </section>
          </div>
          <div class="mobile-hidden">
            <img loading="lazy" class="" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726660918/Line_1_2_edndkn.png" alt="">
          </div>
          <aside class="flex flex-col ml-0 md:ml-5 w-full md:w-3/12 mt-10 md:mt-0">
            <div class="flex flex-col items-start text-3xl md:text-3xl  text-white">
              <h1 class="self-start text-4xl font-semibold text-white">Duration</h1>
              <p class="pt-4 text-lg  text-white">9 weeks</p>
              <h1 class="self-start text-4xl font-semibold text-white pt-8">Group of 5</h1>
              <h1 class="self-start text-4xl font-semibold text-white pt-10">Tools</h1>
              <p class="pt-6 text-lg  text-white">
                Figma, Canva, Miro, Premier Pro, Video Ask
              </p>
            </div>
          </aside>
        </div>
      </section>
      <!-- end of section two -->
  
      <section
  v-if="isVisible"
  class="md:mt-64 mt-10 wangos-border container mx-auto flex justify-start  transition transform duration-500 ease-in-out"
  :class="{'opacity-0 scale-0': !inView, 'opacity-100 scale-100': inView}"
  ref="popupSection"
>
  <article class="flex flex-col m-2  z-10 background-wangos2 justify-center  w-full  rounded-[50px]  max-md:max-w-full">
    <div class="flex z-40 flex-col p-10  rounded-[50px]  max-md:pl-5 max-md:max-w-full">
      <p class="pt-6 text-lg  font-semibold text-amber-50 max-md:max-w-full text-center">
       This redesign has significantly enhanced the organization's visibility and strengthened its partnerships.
        <br /><br /><br />
       Since the completion of the project, Warrior Wagons INC. has partnered with the 
        <span class="text-rose-300">Children's Hospital of Wisconsin (Milwaukee Campus)</span>
         and the 
        <span class="text-rose-300">Sanford Children's Hospital Sioux Falls</span>
        and more volunteers have joined the non-profit. The organization continues to grow and spread its good cause.
      </p>
      <p class="self-center pt-6 text-lg md:pt-16 font-semibold text-amber-50 max-md:max-w-full">
        <span class="text-amber-50">Checkout the website: </span>
        <a href="http://www.warriorwagonsinc.com/" class="text-rose-300 underline" target="_blank" rel="noopener noreferrer">http://www.warriorwagonsinc.com/</a>
      </p>
    </div>
  </article>
</section>

      <!-- end of section three -->
    </main>
  </div>
  <!-- Add responsiveness to other sections similarly -->
          <div>
          <main>
          <!-- section four -->
          <section class="md:mt-64 md:mb-0  mt-10 px-10 background-wangoss h-[200px]  max-md:mt-10 ">
            <div class="p-10 flexmobile gap-20 flex justify-between items-center text-center">
             <div class="">
                <p class="text-white text-xl md:text-2xl">Increased Uniquie Website Visitors by</p>
                    <p class="text-white pt-8 text-3xl md:text-5xl font-bold">23%</p>
             </div>
             <div>
                <p class="text-white text-xl md:text-2xl">Boosted Organic User Growth on Social Media by</p>
                    <p class="text-white pt-8 text-3xl md:text-5xl font-bold">42%</p>
             </div>
             <div>
                <p class="text-white text-xl md:text-2xl">Reduced Website Abandonment Rate by</p>
                    <p class="text-white pt-8 text-3xl md:text-5xl font-bold">32%</p>
             </div>
            </div>
          </section>
          <!-- end of four -->
          </main>
          </div>


          <main class="container mx-auto">
          <!-- five section  -->
         <!-- section four -->
         <section class="flex flexmobile container mb-20 gap-2 ml-10 px-20 mt-10 md:mt-64 justify-between items-center">
  <div class="flex flexmobile flex-col rounded-none max-w-small-mobile max-w-[500px]">
    <h1 class="text-white font-semibold -ml-32 pt-10 md:pt-20 text-2xl md:text-4xl">About</h1>
    <p class="pt-6 -ml-32  text-lg md:pt-16 text-white">Warrior Wagons is a <span class="text-rose-300">non-profit</span> organization who aim to spread awareness about <span class="text-rose-300">pediatric cancer</span> and help young patients and their families at the hospitals by providing with <span class="text-rose-300">personalized wagons.</span> This initiative started out as a gesture of gratitude by the <span class="text-rose-300">Becker family on behalf of their son.</span> The organization <span class="text-rose-300">liaises with the hospitals to acquire patient information</span> and facilitate the provision of wagons, aiming to bring comfort and assistance to those affected by pediatric cancer. </p>
  </div>
  <div class="flex items-center ml-36">
    <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726660970/6418f9e6b7382_1_1_1_obi9q9.png" alt="">
  </div>
</section>

</main>


          <!-- section sex -->
        <div class="mt-64 background-wangoss">
            <section class="flex flexmobile   px-20 mx-auto flex-col rounded-none">
      <div class="flex flex-col px-16 pt-28 pb-72 w-full max-md:px-5 max-md:py-24 max-md:max-w-full">
        <div class="-mb-14 max-md:mb-2.5 max-md:max-w-full">
          <div class="flex justify-between gap-44 max-md:flex-col">
            <div class="flex flex-col  w-[30%] max-md:ml-0 max-md:w-full">
              <div class="flex flex-col w-full text-white max-md:mt-10">
                <div class="flex gap-3 self-center -ml-28 max-w-full text-6xl font-bold whitespace-nowrap w-[80px] max-md:text-4xl">
                    <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/bbcb65d60135832709a2e4837b80b80f16aecd3290086472b5a89ec621fc784e?placeholderIfAbsent=true&apiKey=d64a437ab8f64a9ca8fc16914b2d583b" alt="Wagon donation statistic icon" class="object-contain shrink-0 max-w-full rounded-none aspect-[1.07] w-[120px]" />
                  <p class="text-white pt-2 text-4xl md:text-5xl font-bold">450+</p>
                </div>
                <p class="text-white text-xl md:text-2xl pt-6 text-center ">
                    Wagons donated since 2017
                </p>
              </div>
            </div>
            <div class="flex flex-col ml-5 w-[30%] max-md:ml-0 max-md:w-full">
              <div class="flex flex-col w-full text-white max-md:mt-10">
                <div class="flex gap-3 self-center -ml-8 max-w-full text-6xl font-bold whitespace-nowrap w-[80px] max-md:text-4xl">
                    <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/95ed2d62c8ec8db14b47933d77c038155f35cdd51500203d3db5f38bc650d9fa?placeholderIfAbsent=true&apiKey=d64a437ab8f64a9ca8fc16914b2d583b" alt="Volunteer statistic icon" class="object-contain shrink-0 max-w-full aspect-[0.94] w-[120px]" />
                  <p class="text-white pt-2 text-4xl md:text-5xl font-bold">11+</p>
                </div>
                <p class="text-white text-xl md:text-2xl pt-6 text-center">
                    Volunteers Helping Us
                </p>
              </div>
            </div>
           
            <div class="flex flex-col ml-5 w-[30%] max-md:ml-0 max-md:w-full">
              <div class="flex flex-col w-full text-white max-md:mt-10">
                <div class="flex gap-3 self-center  max-w-full text-6xl font-bold whitespace-nowrap w-[80px] max-md:text-4xl">
                  <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/a447560fa7529cf20930a1bb7c71f9d8336f79add0b56031059cad9f1d315560?placeholderIfAbsent=true&apiKey=d64a437ab8f64a9ca8fc16914b2d583b" alt="Hospital partnership statistic icon" class="object-contain shrink-0 max-w-full aspect-square w-[120px]" />
                  <p class="text-white pt-2 text-4xl md:text-5xl font-bold">6</p>
                </div>
                <p class="text-white text-xl md:text-2xl text-center pt-6">
                  Partnered Hospitals
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
        </div>
          <!-- section seven -->
          <section class="flex mt-10 mx-auto container flex-col justify-center items-center">
            <div>
                <img
        loading="lazy"
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/b42786b9b519953d482360940b830a98582c068f7249bff0bb347ef8ed314fb1?placeholderIfAbsent=true&apiKey=d64a437ab8f64a9ca8fc16914b2d583b"
        class="object-contain w-full aspect-[1.04] max-w-[482px]"
        alt="Descriptive text for the image"
      />
            </div>
            <div>
                <p class="text-white text-3xl pt-6 dancing-script">The Becker Family</p>
            </div>
          </section>
      <!-- section eight  -->
      <section
    class="md:mt-44 flexmobile h-full  mx-auto px-20  transition transform duration-500 ease-in-out"

  >
    <article class=" md:mt-64  wangos-border  mx-auto    w-full  bg-white bg-opacity-0 rounded-[50px] shadow-[0px_4px_10px_rgba(246,238,191,1)] max-md:max-w-full">
     <div class=" background-wangos2 p-10 m-2 h-full">
      <div class="flex flex-col   rounded-[50px] max-md:pl-5 max-md:max-w-full">
        <p class="font-medium text-center text-xl md:text-2xl p-10 text-amber-50 max-md:max-w-full">
            Today, the organization collaborates with coordinators and volunteers from six hospitals spanning across four states... <span class="text-rose-300">Minnesota, Wisconsin, Illinois & South Dakota.</span>
        </p>
      </div>
      </div>
    </article>
  </section>
  <!-- section 9 -->
  <section class="flex flexmobile2 container mt-10 md:mt-80 justify-center items-center  mx-auto flex-col rounded-none">
<div class="relative">
  <!-- Image mockup -->
  <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726657414/MacBook_Pro_awxwkk.png" alt="MacBook Mockup" class="w-full mockup-image">

  <!-- Image slider -->
  <div class="slider-container absolute w-[77.5%] md:w-[100%] md:h-[84%] top-2 left-[2.4rem] md:top-8 md:left-32 overflow-hidden">
    <div class="slider flex" :style="sliderStyle">
      <div v-for="(image, index) in images" :key="index" class="w-full slide">
        <img loading="lazy" :src="image.src" :alt="'Slide ' + (index + 1)" class="w-full h-full object-cover">
      </div>
    </div>
    <button class="prev absolute top-1/2 left-2 transform -translate-y-1/2" @click="moveSlide(-1)">&#10094;</button>
    <button class="next absolute top-1/2 right-2 transform -translate-y-1/2" @click="moveSlide(1)">&#10095;</button>
  </div>
</div>
</section>


   <WangosProjectTwo/>
   <WangosProjectThree/>
   <WangosProjectFour/>
  </div>

        </template>


<script>
import WangosProjectTwo from './WangosProjectTwo.vue'
import WangosProjectThree from './WangosProjectThree.vue'
import WangosProjectFour from './WangosProjectFour.vue'
export default{
    name:'WangosProject',
    components:{
        WangosProjectTwo,
        WangosProjectThree,
        WangosProjectFour
    },
    data() {
    return {
      inView: false, // Controls the appearance of the pop-up
      isVisible: true,
    currentSlide: 0,
    images: [
    { src: ('https://res.cloudinary.com/dkdzcp4au/image/upload/v1726661598/Our_Story_hc3ske.png') },
    { src: ('https://res.cloudinary.com/dkdzcp4au/image/upload/v1726661728/Get_Involved_Find_Support_1_qn9see.png') },
    { src: ('https://res.cloudinary.com/dkdzcp4au/image/upload/v1726661775/Get_Involved_Volunteer_qlfts1.png') },
    { src: ('https://res.cloudinary.com/dkdzcp4au/image/upload/v1726661821/Donate_a_Wagon_1_1_ywaygz.png') },
    { src: ('https://res.cloudinary.com/dkdzcp4au/image/upload/v1726661862/Contact_1_sbnaxw.png') },
    { src: ('https://res.cloudinary.com/dkdzcp4au/image/upload/v1726661875/News___Events_1_cdko4k.png') },
],

  };
  },
  computed: {
  sliderStyle() {
    return {
      transform: `translateX(${-this.currentSlide * 100}%)`,
    };
  },
},
  methods: {
    showSlide(index) {
    const totalSlides = this.images.length;
    if (index >= totalSlides) {
      this.currentSlide = 0;
    } else if (index < 0) {
      this.currentSlide = totalSlides - 1;
    } else {
      this.currentSlide = index;
    }
  },
  moveSlide(step) {
    this.showSlide(this.currentSlide + step);
  },
  },
  mounted() {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.inView = true;
        }
      },
      {
        root: null, // viewport
        threshold: 0.1, // 10% of the element in view
      }
      
    );
   // Optional: Auto-slide
   this.autoSlideInterval = setInterval(() => {
    this.moveSlide(1);
  }, 5000); // Change slide every 5 seconds
    observer.observe(this.$refs.popupSection);
  },
  
  beforeUnmount() {
  clearInterval(this.autoSlideInterval); // Clean up interval on component destruction
},
}
</script>

<style>
.background-wangos{
  background: linear-gradient(180deg, rgba(192, 84, 80, 0.50) 0%, rgba(104, 49, 47, 0.60) 35.8%, rgba(59, 32, 31, 0.70) 54.37%, rgba(37, 23, 22, 0.80) 71.27%, rgba(26, 18, 18, 0.95) 84.36%, #0F0E0E 99.59%);
}
.background-wangoss{
  background: linear-gradient(180deg, rgba(192, 84, 80, 0.50) 0%, rgba(104, 49, 47, 0.60) 35.8%, rgba(59, 32, 31, 0.70) 54.37%, rgba(37, 23, 22, 0.80) 71.27%, rgba(26, 18, 18, 0.95) 84.36%, #0F0E0E 99.59%);

}
.wangos-border{
  border-radius: 50px;
border: 1px solid #F6B4B2;
background: rgba(255, 255, 255, 0.00);
box-shadow: 0px 4px 10px 0px #F6EEBF, 4px 4px 1px -50px #F6EEBF inset;
backdrop-filter: blur(20px);
}
.background-wangos2 {
  border-radius: 50px;

background: linear-gradient(99deg, #65302E 0.22%, rgba(196, 193, 199, 0.31) 56.45%, rgba(255, 255, 255, 0.05) 100%);
box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.50);
backdrop-filter: blur(20px);
}
@media (max-width:640px){
    .flexmobile{
        display: block;
        margin-left: 0;
        padding: 10px;
        margin-top: 150px;
        gap: 0 !important;
        font-size: 20px;
    }
    .background-wangos{
        background-size: cover;
    }
    .background-wangos2{
        background-image: none;
    }
    .max-w-small-mobile{
        max-width: 100%;
        width: 100%;
    }
}

.opacity-0 {
  opacity: 0;
}
.scale-0 {
  transform: scale(0);
}
.opacity-100 {
  opacity: 1;
}
.scale-100 {
  transform: scale(1);
}

.mockup-image {
width: 100%;
height: auto;
}

.slider-container {
position: absolute;
top: 4.5%;
left: 11.5%;
width: 77%;
height: 100%;
overflow: hidden;
}

.slider {
display: flex;
transition: transform 0.5s ease-in-out;
}

.slide {
min-width: 100%;
box-sizing: border-box;
}

.prev,
.next {
position: absolute;
top: 50%;
transform: translateY(-50%);
background-color: rgba(0, 0, 0, 0.5);
color: white;
border: none;
padding: 10px;
cursor: pointer;
z-index: 10;
}

.prev {
left: 10px;
}

.next {
right: 10px;
}

</style>
